import React from "react";

var flagSvg = function flagSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 12.03v-11c.324-.02.657-.03 1-.03 3 0 2.975 1 6 1 1.407 0 2.643-.162 3.709-.486A1 1 0 0 1 16 2.47v8.881a1 1 0 0 1-.634.93C14.15 12.762 12.695 13 11 13c-3 0-3-1-6-1-.343 0-.676.01-1 .03zM2 1v15H0V1a1 1 0 1 1 2 0z"
  }));
};

flagSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var flag = {
  category: 'icon',
  colorable: true,
  name: 'flag',
  svg: flagSvg
};